import { SignInUrlBuilder } from '@tableau/shared-urls';
import React from 'react';

import { LoginSitePickerComponent } from '~src/userManagement/components/siteRolePicker/LoginSitePickerComponent';

import { DefaultServerTitleWrapper } from '../../../authentication/components/loginSpace/DefaultServerTitleWrapper';
import { MobileAppBanner } from '../../../mobile/components/MobileAppBanner';
import { ProcessAndRemoveSamlQueryWrapper } from '../../../spacesPlatform/routerHelpers/saml/ProcessAndRemoveSamlQueryWrapper';

export interface SitePickerProviderProps {
  readonly routeLocationSearch: string;
}

export function SitePickerProvider(props: SitePickerProviderProps): JSX.Element {
  return (
    <DefaultServerTitleWrapper>
      <ProcessAndRemoveSamlQueryWrapper>
        <div>
          <MobileAppBanner />
        </div>
        <div>
          <LoginSitePickerComponent {...this.props} sitePickerQueryParams={SignInUrlBuilder.queryParamsFromQuery(props.routeLocationSearch)}/>
        </div>
      </ProcessAndRemoveSamlQueryWrapper>
    </DefaultServerTitleWrapper>
  );
}
